import { endOfMonth, startOfMonth } from 'date-fns';
import { CampaignSubSource } from 'utils/constants/campaign';
import { previousMonth } from 'utils/date';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type Vat = boolean;
type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

export enum IncomeExpenseReportType {
    AllWithoutBonus = 'ALL_WITHOUT_BONUS',
    Inner = 'INNER',
    Outer = 'OUTER',
    Bonus = 'BONUS',
}

interface IncomeExpenseData {
    date: string;
    expense: number;
    incoming: number;
    sources: Record<CampaignSubSource, number>;
}

// ----------------------- actions -------------------------------------
const SET_DATES_INCOME_EXPENSE = 'SET_DATES_INCOME_EXPENSE';
const SET_TYPE_INCOME_EXPENSE = 'SET_TYPES_INCOME_EXPENSE';
const SET_VAT_INCOME_EXPENSE = 'SET_VAT_INCOME_EXPENSE';
const SET_DATA_INCOME_EXPENSE = 'SET_DATA_INCOME_EXPENSE';
const SET_IS_LOAD_INCOME_EXPENSE_DATA = 'SET_IS_LOAD_INCOME_EXPENSE_DATA';

interface PayloadTypes {
    [SET_DATES_INCOME_EXPENSE]: { from: FromDate; to: ToDate };
    [SET_TYPE_INCOME_EXPENSE]: IncomeExpenseReportType;
    [SET_VAT_INCOME_EXPENSE]: Vat;
    [SET_DATA_INCOME_EXPENSE]: IncomeExpenseData[];
    [SET_IS_LOAD_INCOME_EXPENSE_DATA]: IsLoad;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setDates = ActionCreator(SET_DATES_INCOME_EXPENSE);
export const setTypeReport = ActionCreator(SET_TYPE_INCOME_EXPENSE);
export const setVat = ActionCreator(SET_VAT_INCOME_EXPENSE);
export const setIncomeExpenseData = ActionCreator(SET_DATA_INCOME_EXPENSE);
export const setLoadIncomeExpenseData = ActionCreator(SET_IS_LOAD_INCOME_EXPENSE_DATA);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface IncomeExpenseState {
    from: FromDate;
    to: ToDate;
    typeReport: IncomeExpenseReportType;
    vat: Vat;
    incomeExpenseData: IncomeExpenseData[];
    isLoad: IsLoad;
}

export const INCOME_EXPENSE_INITIAL_STATE: IncomeExpenseState = {
    from: startOfMonth(previousMonth),
    to: endOfMonth(previousMonth),
    typeReport: IncomeExpenseReportType.AllWithoutBonus,
    vat: false,
    incomeExpenseData: [],
    isLoad: false,
};

export default createReducer<IncomeExpenseState, PayloadTypes>(INCOME_EXPENSE_INITIAL_STATE, {
    [SET_DATES_INCOME_EXPENSE]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_TYPE_INCOME_EXPENSE]: (state, { payload }) => ({
        ...state,
        typeReport: payload,
    }),
    [SET_VAT_INCOME_EXPENSE]: (state, { payload }) => ({
        ...state,
        vat: payload,
    }),
    [SET_DATA_INCOME_EXPENSE]: (state, { payload }) => ({
        ...state,
        incomeExpenseData: payload.reverse(),
    }),
    [SET_IS_LOAD_INCOME_EXPENSE_DATA]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
